import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { ArrowUpRight } from "lucide-react";

export default function CalculatorCard({ calc }) {
  const Icon = Icons[calc.icon] || Icons.Calculator;
  return (
    <Link
      to={`/calculators/${calc.slug}`}
      data-testid={`card-${calc.slug}`}
      className="group relative flex flex-col rounded-2xl border border-border bg-card p-5 transition hover:-translate-y-0.5 hover:shadow-[0_8px_24px_-8px_rgba(0,0,0,0.15)] hover:border-foreground/25"
    >
      <div className="flex items-start justify-between">
        <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-secondary text-foreground group-hover:bg-primary group-hover:text-primary-foreground transition">
          <Icon className="h-5 w-5" strokeWidth={1.75} />
        </span>
        <ArrowUpRight className="h-4 w-4 text-muted-foreground opacity-0 group-hover:opacity-100 transition" />
      </div>
      <h3 className="mt-4 text-base font-semibold leading-snug">{calc.name}</h3>
      <p className="mt-1 text-sm text-muted-foreground leading-relaxed">{calc.description}</p>
    </Link>
  );
}
